var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncrementalRevenues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.743,
    height: 25.639,
    viewBox: "0 0 117.743 25.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(-3922 -511.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M3953.624,536.8H3922v-1.381h31.624a28.275,28.275,0,0,0,13.414-3.485l32.064-17.126a29.631,29.631,0,0,1,14.064-3.647h26.577v1.38h-26.577a28.284,28.284,0,0,0-13.414,3.484l-32.064,17.127A29.62,29.62,0,0,1,3953.624,536.8Z",
    fill: "#3deba8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M4039.743,536.8h-26.577a29.62,29.62,0,0,1-14.064-3.648l-32.064-17.127a28.284,28.284,0,0,0-13.414-3.484H3922v-1.38h31.624a29.637,29.637,0,0,1,14.064,3.647l32.064,17.126a28.272,28.272,0,0,0,13.414,3.485h26.577Z",
    fill: "#f52c57"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementalRevenues);
export default __webpack_public_path__ + "static/media/incremental-revenues.6ed8dbd0af1a2060701078fd3a163579.svg";
export { ForwardRef as ReactComponent };